module.exports = __webpack_public_path__ + "static/img/team6.6a70186.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team6.png
// module id = 7vxv
// module chunks = 1